export const SOCIAL_MEDIA_DOMAINS = [
  'instagram.com',
  'www.instagram.com',
  'linkedin.com',
  'www.linkedin.com',
  'tiktok.com',
  'www.tiktok.com',
  'facebook.com',
  'www.facebook.com'
];

export const BLACKLISTED_DOMAINS = [...SOCIAL_MEDIA_DOMAINS];

export const isDomainBlacklisted = (url: string): boolean => {
  try {
    const urlObject = new URL(url);
    return BLACKLISTED_DOMAINS.some(domain => 
      urlObject.hostname === domain || urlObject.hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
};

export const isSocialMediaDomain = (url: string): boolean => {
  try {
    const urlObject = new URL(url);
    return SOCIAL_MEDIA_DOMAINS.some(domain => 
      urlObject.hostname === domain || urlObject.hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
};